import { faPlus } from "@fortawesome/pro-solid-svg-icons/faPlus";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Tooltip } from "@mantine/core";

interface InviteButtonProps {
  disabled: boolean;
  disabledReason?: string;
  loading: boolean;
  onClick: () => void;
}

export const InviteButton = ({
  disabled,
  disabledReason,
  loading,
  onClick,
}: InviteButtonProps) => {
  const button = (
    <Button
      className="disabled:opacity-50 h-8 px-3 gap-1 text-sm font-semibold"
      color="purple.5"
      disabled={disabled}
      loading={loading}
      onClick={onClick}
      radius={4}
      rightSection={<FontAwesomeIcon icon={faPlus} size="xs" />}
    >
      Invite
    </Button>
  );

  if (disabled && disabledReason) {
    return (
      <Tooltip label={disabledReason} withArrow>
        <span>{button}</span>
      </Tooltip>
    );
  }

  return button;
};
